var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('codemirror',{staticClass:"code-editor",attrs:{"options":_vm.options},on:{"input":_vm.change},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }